/**
 * FareViewModel — map only fields present; never invent policy text.
 * @param {object|null|undefined} offer
 * @returns {import("../types").FareViewModel}
 */
export function mapFareViewModel(offer) {
  const meta = offer?.cardMeta || {};
  const raw = offer?.rawDeal;
  const cabin =
    strOrNull(offer?.cabin) ||
    strOrNull(offer?.cabinClass) ||
    strOrNull(meta.cabin) ||
    null;
  const fareFamily =
    strOrNull(offer?.fareFamily) ||
    strOrNull(offer?.fare_family) ||
    strOrNull(raw?.fareFamily) ||
    null;
  const fareType =
    strOrNull(offer?.fareType) ||
    strOrNull(meta.flightCategory) ||
    strOrNull(raw?.flightCategory) ||
    null;

  let charter = null;
  const cat = String(fareType || meta.flightCategory || "").toLowerCase();
  if (cat.includes("charter")) charter = true;
  else if (offer?.isCharter === true) charter = true;
  else if (offer?.isCharter === false) charter = false;

  return {
    cabin,
    fareFamily,
    fareType,
    charter,
    changePolicy: strOrNull(offer?.changePolicy) || null,
    cancelPolicy: strOrNull(offer?.cancelPolicy) || null,
    refundability: strOrNull(offer?.refundability) || null,
    ticketingDeadline:
      strOrNull(offer?.ticketingDeadline) ||
      strOrNull(offer?.paymentRequirements?.paymentRequiredBy) ||
      null,
  };
}

function strOrNull(v) {
  if (v == null) return null;
  const s = String(v).trim();
  return s || null;
}
